import { Android, PhoneAndroid } from "@mui/icons-material";
import { Chip, Sheet, Stack, Typography } from "@mui/joy";
import * as React from "react";

export default function InstallPwa() {
  const [supportsPWA, setSupportsPWA] = React.useState(false);
  const [promptInstall, setPromptInstall] = React.useState(null);

  React.useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log("we are being triggered :D");
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    if (document.referrer.startsWith("android-app://")) {
      return "twa";
    } else if (navigator.standalone || isStandalone) {
      return "standalone";
    } else {
      window.addEventListener("beforeinstallprompt", handler);
    }

    window.addEventListener("appinstalled", () => {
      // Hide the app-provided install promotion
      setSupportsPWA(false);
      // Clear the deferredPrompt so it can be garbage collected
      setPromptInstall(null);
      // Optionally, send analytics event to indicate successful install
      console.log("PWA was installed");
    });

    return () => window.removeEventListener("transitionend", handler);
  }, []);

  const cancel = () => {
    setSupportsPWA(false);
  };

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };

  if (!supportsPWA) {
    return null;
  }

  return (
    <>
      <Sheet
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          width: "100vw",

          zIndex: 9995,
          padding: "10px 10px",
          borderBottom: "1px solid",
          borderColor: "background.level1",
        }}
        variant="soft"
        color="primary"
      >
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <Typography level="body-md">Install for android</Typography>{" "}
          <PhoneAndroid fontSize="large" />
        </Stack>
        <Chip
          startDecorator={<Android />}
          size="lg"
          variant="outlined"
          onClick={onClick}
        >
          Install
        </Chip>
      </Sheet>
    </>
  );
}
